import * as types from "../../constants/actionTypes";
import moment from "moment";

const initState = {
  isLoading: false,
  listNegara: [],
  listPasien: [],
  masterData: [],
  listJenisKelamin: [],
  listGolonganDarah: [
    { id: "", name: "Pilih golongan darah", isDisabled: "true" },
    { id: "A", name: "A" },
    { id: "B", name: "B" },
    { id: "O", name: "O" },
    { id: "AB", name: "AB" },
  ],
  listStatusPerokok: [
    { id: "", name: "Apakah anda perokok?", isDisabled: "true" },
    { id: "0", name: "Tidak Merokok" },
    { id: "10", name: "Ya, Merokok" },
    { id: "20", name: "Pernah Merokok" },
  ],
  formPasien: {
    id_pasien: "",
    date_register: moment().format("YYYY-MM-DD HH:mm:ss"),
    nama_pasien: "",
    telepon_pasien: "",
    tgl_lahir: "",
    umur_pasien: "",
    jenis_kelamin: "",
    no_identitas: "",
    golongan_darah: "",
    status_perokok: "",
    no_alamat_pasien: "",
    catatan: "",
    email_user: "",
    id_negara: "100",
    temp_lokasi: "",
    id_kesehatan_pasien: "",
  },
};

export default function (state = initState, action) {
  switch (action.type) {
    case types.MODULE_PASIEN_SET_LOADER: {
      return {
        ...state,
        isLoading: action.value,
      };
    }
    case types.HANDLE_STATE_OUTER: {
      return {
        ...state,
        [action.property]: action.value,
      };
    }
    case types.MODULE_PASIEN_MASTER_DATA_SUCCESS: {
      return {
        ...state,
        masterData: {
          ...state.masterData,
          [action.property]: action.value,
        },
      };
    }
    case types.MODULE_PASIEN_DATA_GET_ALL_SUCCESS: {
      return {
        ...state,
        listPasien: action.value,
      };
    }
    case types.MODULE_PASIEN_DATA_GET_DETAIL_SUCCESS: {
      return {
        ...state,
        formPasien: {
          ...action.payload,
        },
      };
    }
    case types.HANDLE_STATE_FORM_TAMBAH_PASIEN: {
      if (action.property == "tgl_lahir") {
        return {
          ...state,
          formPasien: {
            ...state.formPasien,
            tgl_lahir: action.value,
            umur_pasien: moment().diff(moment(action.value, "YYYY-MM-DD"), "years", false),
          },
        };
      } else {
        return {
          ...state,
          formPasien: {
            ...state.formPasien,
            [action.property]: action.value,
          },
        };
      }
    }
    case types.INIT_FORM_TAMBAH_PASIEN: {
      return {
        ...state,
        formPasien: {
          ...initState.formPasien,
        },
      };
    }
    default:
      return {
        ...state,
      };
  }
}
